import React from 'react';
import { NavLink } from 'react-router-dom';

import { Container, Row, Col } from 'react-bootstrap';
import '../App.css';

/* 아이콘 */
import { BiStoreAlt } from "react-icons/bi";
import { GoSearch } from "react-icons/go";
import { AiOutlineGift } from "react-icons/ai";
import { LuCalendarCheck } from "react-icons/lu";
import { FaUser } from "react-icons/fa";


const Footer = () => {

    const activeStyle = {
        color: '#ffffff'
    };

    return (
        <>
            <Container className='footer'>
                <Row>
                    <Col>
                        <NavLink className='link' to='/Main'
                            style={({ isActive }) => (isActive ? activeStyle : {})}
                        >
                            <BiStoreAlt className='Ficon' /><br />
                            홈
                        </NavLink>
                    </Col>
                    <Col>
                        <NavLink className='link' to="/Fsearch"
                            style={({ isActive }) => (isActive ? activeStyle : {})}
                        >
                            <GoSearch className='Ficon' /><br />
                            검색
                        </NavLink>
                    </Col>
                    <Col>
                        <NavLink className='link' to='/Experience'
                            style={({ isActive }) => (isActive ? activeStyle : {})}
                        >
                            <AiOutlineGift className='Ficon' /><br />
                            체험단
                        </NavLink>
                    </Col>
                    <Col>
                        <NavLink className='link' to='/Reservation'
                            style={({ isActive }) => (isActive ? activeStyle : {})}
                        >
                            <LuCalendarCheck className='Ficon' /><br />
                            예약
                        </NavLink>
                    </Col>
                    <Col>
                        <NavLink className='link' to='/Ai'
                            style={({ isActive }) => (isActive ? activeStyle : {})}
                        >
                            <FaUser className='Ficon' /><br />
                            Ai 인식
                        </NavLink>
                    </Col>
                </Row>
            </Container>
        </>
    )
};

export default Footer;